import { CheckBadgeIcon, InboxIcon, KeyIcon, PaperAirplaneIcon, TrashIcon, UserCircleIcon } from "@heroicons/react/24/outline";
import { ArrowPathIcon, ArrowRightCircleIcon, CheckCircleIcon } from "@heroicons/react/24/solid";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { FC, useEffect } from "react";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import logoImg from "../../../assets/images/logo.jpeg";
import {
  ButtonPrimary,
  FloatInput
} from "../../../components";
import { changePassword, clearState, forgotPassword, verifiedForgotPassword } from "../services/AuthSlice";
import { useSearchParams } from "react-router-dom";
import jwtDecode from "jwt-decode";


export interface PageForgotPasswordProps {
  className?: string;
}

type ForgotPasswordForm = {
  Password: string;
  ConfPassword: string;
};

const VerifiedForgotPassword: FC<PageForgotPasswordProps> = ({ className = "" }) => {
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  const _credentials = searchParams.get("credentials")

  const { isChangePasswordSuccess, isVerifiedForgotPasswordSuccess, isError, isFetching, errorMessage } =
    useAppSelector((state) => state.auth);

  const validationSchema = Yup.object().shape({
    Password: Yup.string()
      .required("Password is required")
      .min(8, "Kata sandi minimal memiliki 8 karakter")
      .max(40, "Kata sandi tidak dapat memiliki lebih dari 40 karakter"),
    ConfPassword: Yup.string().oneOf(
      [Yup.ref("Password"), null],
      "Kata sandi tidak sama"
    ),
  });

  const {
    getValues,
    register,
    handleSubmit,
    // reset,
    formState: { errors },
  } = useForm<ForgotPasswordForm>({
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {

    async function _verifiedForgotPassword() {
      if (_credentials) {
        dispatch(verifiedForgotPassword(
          {
            body: {
              FORGOT_PASSWORD: {
                Token: _credentials,
              },
            },
            headers: {
              "X-System-Auth": ""
            }
          }
        ))
      }
    }

    _verifiedForgotPassword()

  }, [dispatch]);

  const doChangePassword = (data: ForgotPasswordForm) => {

    if (_credentials) {
      let user = {
        userid: "",
      }

      user = jwtDecode(_credentials)

      if (user) {
        dispatch(
          changePassword({
            body: {
              CHANGE_PASSWORD: {
                Userid: user.userid,
                Password: data.Password
              },
            },
            headers: {
              "X-System-Auth": ""
            }
          })
        );
      }
    }
  }

  const renderForm = () => {
    return (
      <>
        <div className="mb-2"></div>
        <FloatInput
          Icon={KeyIcon}
          type="password"
          id="password"
          label="Kata Sandi"
          {...register("Password")}
          isError={errors.Password}
          errorMessage={errors.Password?.message}
        />
        <div className="mb-2"></div>
        <FloatInput
          Icon={KeyIcon}
          type="password"
          id="confPassword"
          label="Konfirmasi Kata Sandi"
          {...register("ConfPassword")}
          isError={errors.ConfPassword}
          errorMessage={errors.ConfPassword?.message}
        />
        {/* {isError && (
          <>
            <div className="mb-2"></div>
            <div
              className="p-1 text-xs rounded-full bg-red-300 items-center text-gray-800 leading-none lg:rounded-full flex lg:inline-flex"
              role="alert">
              <span className="flex mr-3">
                <XCircleIcon className="w-5 text-red-500" />
              </span>
              <span className="font-semibold mr-2 text-left flex-auto">
                {errorMessage}
              </span>
              <svg
                className="fill-current opacity-75 h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20">
                <path d="M12.95 10.707l.707-.707L8 4.343 6.586 5.757 10.828 10l-4.242 4.243L8 15.657l4.95-4.95z" />
              </svg>
            </div>
          </>
        )} */}
        <div className="mb-6"></div>
        <ButtonPrimary
          loading={isFetching}
          className="w-full"
          type="submit"
        >
          Ubah Kata Sandi
          <PaperAirplaneIcon className="ml-4 w-5" />
        </ButtonPrimary>
      </>
    )
  }

  return (
    <div className={`nc-PageForgotPassword bg-gray-100 ${className}`} data-nc-id="PageForgotPassword">
      <div className="container h-screen flex w-full justify-center">
        <div className="flex w-full lg:w-1/2 justify-center items-center ">
          <div className="w-full md:px-32 lg:px-24">

            <form
              onSubmit={handleSubmit(doChangePassword)}
              className="bg-white rounded-md shadow-2xl p-3 md:p-5 -mt-40">
              <div className="w-full flex flex-row justify-start space-x-5 items-center">
                <img
                  className={`block max-h-16`}
                  src={logoImg}
                  alt="Logo"
                />
               
              </div>
              {/* <h1 className="text-gray-600 font-bold text-2xl">
                Selamat Datang
              </h1>*/}

              {
                isVerifiedForgotPasswordSuccess ?
                  <>
                    {
                      isChangePasswordSuccess ?
                        <>
                          <h1 className="flex flex-row mt-10 mb-4 text-green-500 text-sm md:text-lg leading-4 md:leading-5 w-full justify-start items-start">
                            <CheckCircleIcon className="w-5 mr-3" /> Berhasil
                          </h1>

                          <ButtonPrimary
                            className="w-full"
                            type="button"
                            href="https://ptsp.halal.go.id"
                            external
                          >
                            Masuk
                            <ArrowRightCircleIcon className="ml-5 w-5" />
                          </ButtonPrimary>
                        </>
                        :
                        <>
                          <h1 className="mt-10 mb-4 text-gray-500 text-sm md:text-md leading-4 md:leading-5 w-full flex flex-col justify-start items-start">
                            Masukan kata sandi baru
                          </h1>
                          {renderForm()}
                        </>
                    }

                  </>
                  :
                  <>
                    <h1 className="mt-10 mb-4 text-red-600 text-sm md:text-md leading-4 md:leading-5 w-full flex flex-col justify-start items-start">
                      <span>
                        Terdapat Kesalahan
                      </span>
                    </h1>

                    <ButtonPrimary
                      className="w-full"
                      type="button"
                      href="/forgot_password"
                    >
                      kirim ulang
                      <ArrowPathIcon className="ml-5 w-5" />
                    </ButtonPrimary>
                  </>
              }


              {/* {
                isFetchingAuthSystem ? <>
                  {clientAccess()}
                </> : <>
                  {
                    client ? <> {
                      isAuth ? <>
                        <h1 className="mt-10 text-gray-600 text-sm md:text-xl leading-4 md:leading-5 w-full flex flex-col justify-start items-start">
                          <span>
                            Hi, <span className="font-semibold">{profile?.email_addr}</span>
                          </span>
                          <div className="my-4"></div>
                          <div className="flex flex-row space-x-3 w-full">
                            <ButtonPrimary
                              loading={isFetching}
                              className="w-full"
                              type="button"
                              onClick={() => doSelanjutnnyya()}
                            >
                              Selanjutnya <ArrowRightOnRectangleIcon className="font-bold ml-5 w-6" />
                            </ButtonPrimary>
                          </div>
                        </h1>
                      </>
                        :
                        <> {renderForm()}</>
                    }
                    </> : <>
                      {clientReject()}
                    </>
                  }
                </>
              } */}

            </form>
          </div>
        </div>
      </div>
    </div>
  );


};

export default VerifiedForgotPassword;
